/**
 * Alternates the browser-tab favicon with a red cart-count badge while the tab is
 * backgrounded and the cart has items. Restores the original favicon the moment the
 * tab becomes active again. Never leaves the favicon broken or missing: any canvas
 * failure (e.g. a tainted canvas) degrades to "no badge", not a broken icon.
 */
(function cartFavicon() {
  if (typeof document === 'undefined' || !document.head || window.__tgcCartFaviconInit) return;
  window.__tgcCartFaviconInit = true;

  const FLASH_MS = 800;
  const SIZE = 64;
  const BADGE_BG = '#e5342b';
  const BADGE_FG = '#ffffff';

  const iconLink = document.querySelector('link[rel~="icon"]');
  if (!iconLink || !iconLink.href) return;
  const originalHref = iconLink.href;

  let baseImage = null;
  let plainUrl = null;
  let badgedUrl = null;
  let count = 0;
  let timer = null;
  let showingBadge = false;
  let frame = 0;

  function prefersReducedMotion() {
    try {
      return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    } catch (error) {
      return false;
    }
  }

  function setIconHref(href) {
    frame += 1;
    iconLink.href = href + (href.indexOf('#') === -1 ? '#' : '&') + 'tgc-frame=' + frame;
  }

  function stopFlash() {
    if (timer) {
      clearInterval(timer);
      timer = null;
    }
    showingBadge = false;
  }

  function restoreIcon() {
    stopFlash();
    iconLink.href = originalHref;
  }

  function drawBadge(ctx, itemCount) {
    const label = itemCount > 9 ? '9+' : String(itemCount);
    const radius = SIZE * 0.34;
    const cx = SIZE - radius - SIZE * 0.03;
    const cy = radius + SIZE * 0.03;

    ctx.beginPath();
    ctx.arc(cx, cy, radius, 0, Math.PI * 2);
    ctx.fillStyle = BADGE_BG;
    ctx.fill();
    ctx.lineWidth = SIZE * 0.06;
    ctx.strokeStyle = '#ffffff';
    ctx.stroke();

    ctx.fillStyle = BADGE_FG;
    ctx.font = `700 ${Math.round(label.length > 1 ? radius * 0.95 : radius * 1.3)}px Arial, sans-serif`;
    ctx.textAlign = 'center';
    ctx.textBaseline = 'middle';
    ctx.fillText(label, cx, cy + SIZE * 0.02);
  }

  function buildIcons() {
    if (!baseImage) return;

    try {
      const canvas = document.createElement('canvas');
      canvas.width = SIZE;
      canvas.height = SIZE;
      const ctx = canvas.getContext('2d');
      if (!ctx) return;

      ctx.clearRect(0, 0, SIZE, SIZE);
      ctx.drawImage(baseImage, 0, 0, SIZE, SIZE);
      plainUrl = canvas.toDataURL('image/png');

      drawBadge(ctx, count);
      badgedUrl = canvas.toDataURL('image/png');
    } catch (error) {
      // Tainted canvas or any other draw failure: never badge, never touch the favicon.
      plainUrl = null;
      badgedUrl = null;
    }
  }

  function startFlash() {
    if (prefersReducedMotion()) {
      stopFlash();
      setIconHref(badgedUrl);
      showingBadge = true;
      return;
    }

    if (timer) return;
    showingBadge = false;
    timer = setInterval(() => {
      showingBadge = !showingBadge;
      setIconHref(showingBadge ? badgedUrl : plainUrl);
    }, FLASH_MS);
  }

  function evaluate() {
    if (document.hidden && count > 0 && badgedUrl && plainUrl) {
      startFlash();
    } else {
      restoreIcon();
    }
  }

  function refreshCount() {
    fetch('/cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then((response) => response.json())
      .then((cart) => {
        const next = cart && typeof cart.item_count === 'number' ? cart.item_count : 0;
        if (next !== count) {
          count = next;
          buildIcons();
        }
        evaluate();
      })
      .catch(() => {});
  }

  function loadBaseImage() {
    const img = new Image();
    img.crossOrigin = 'anonymous';
    img.onload = () => {
      baseImage = img;
      buildIcons();
      refreshCount();
    };
    // Image failed to load (e.g. blocked, no CORS headers): leave the favicon untouched.
    img.onerror = () => {};
    img.src = originalHref;
  }

  loadBaseImage();

  document.addEventListener('visibilitychange', evaluate);
  document.addEventListener('cart:update', refreshCount);
})();
